export const ENV = {
  CARTO_KEY: import.meta.env.VITE_CARTO_KEY,
  MAPBOX_TOKEN: import.meta.env.VITE_MAPBOX_TOKEN,
  TOMTOM_KEY: import.meta.env.VITE_TOMTOM_KEY,
  LOCATIONIQ_KEY: import.meta.env.VITE_LOCATIONIQ_KEY,
  MAPY_KEY: import.meta.env.VITE_MAPY_KEY,
  JAWG_KEY: import.meta.env.VITE_JAWG_KEY,
  THUNDERFOREST_KEY: import.meta.env.VITE_THUNDERFOREST_KEY,
  OPENAIP_KEY: import.meta.env.VITE_OPENAIP_KEY,
}
